export function controlledFetch(resource, init) {
  const controller = new AbortController();
  const { signal } = controller;

  return [
    fetch(resource, { ...init, signal }), controller
  ];
}

